import { connect } from 'react-redux';
import { compose, withState, withHandlers, branch, renderNothing } from 'recompose';

import { impersonateUser } from '../../../auth/actions';
import { getIsConnectedUser } from '../../users/selectors';
import withNotifications from '../../../common/withNotifications';
import { isKioskUser, getUserForShop } from '../../shops/selectors';
import { getShop } from '../../shops/reducers';

export const enhance = compose(
  branch(
    props => !props.id || (props.checkKioskUser && !props.shopId),
    renderNothing,
  ),
  connect((state, props) => ({
    isConnectedUser: getIsConnectedUser(state, props.id),
    shop: props.shopId ? getShop(state, props.shopId) : null,
  }), { impersonateUser }),
  withNotifications,
  withState('clicked', 'setClicked', false),
  withHandlers({
    login: props => (e) => {
      e.preventDefault();
      if (props.shop && props.checkKioskUser) {
        if (isKioskUser(getUserForShop(props.id, props.shop))) {
          props.addNotification({
            title: 'Can\'t login',
            level: 'error',
            message: 'In order to login at least one of the shop usernames has to have kiosk permission set to off.',
          });

          return;
        }
      }
      props.setClicked(true);
      props.impersonateUser(props.id, props.shop ? props.shop.id : null);
    },
  }),
);

const hideIfUserNotConnected = (
  branch(
    props => !props.isConnectedUser,
    renderNothing,
  )
);

const enhanceAndHideIfUserNotConnected = compose(
  enhance,
  hideIfUserNotConnected,
);

export default enhanceAndHideIfUserNotConnected;
